export default (file: string) => {
  const a: HTMLAnchorElement = document.createElement('a')
  document.body.appendChild(a)
  // @ts-ignore
  a.style = 'display: none'
  a.href = file
  a.click()
  document.body.removeChild(a)
}
